import { Flex, Text } from "@mantine/core";
import { formatLastUpdated } from "../../mock";
import { useTranslation } from "react-i18next";
interface IProps {
  lastUpdated: Date | undefined;
  title: string;
  handleUpdate: () => void;
}
export default function HeadingOperation({
  lastUpdated,
  title,
  handleUpdate,
}: IProps) {
  const { t } = useTranslation();
  const { translationKey, hourAndDate } = formatLastUpdated(lastUpdated);
  const formattedTextLastUpdated = t(translationKey, { hourAndDate });

  return (
    <Flex direction="column" id="29618" gap={8}>
      <Text
        color="basic.5"
        fz={{ base: 18 }}
        fw={{ base: 700 }}
        lh={{ base: "18px" }}
      >
        {t(title)}
      </Text>
      <Flex gap={16} wrap={{ base: "wrap", 780: "nowrap" }}>
        <Text
          fz={{ base: 16 }}
          lh={{ base: "16px" }}
          color="basic.4"
          style={{ whiteSpace: "nowrap" }}
        >
          {formattedTextLastUpdated}
        </Text>
        <Text
          onClick={handleUpdate}
          td="underline"
          fz={{ base: 16 }}
          fw={{ base: 500 }}
          lh={{ base: "16px" }}
          color="primary.1"
          style={{ cursor: "pointer", whiteSpace: "nowrap" }}
        >
          {t("operacoes.update_now")}
        </Text>
      </Flex>
    </Flex>
  );
}
